import { Injectable } from '@angular/core';
import { BaseServiceErrorResolverService } from '../../../../core/services/error-resolvers/base-service-error-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class LabelsErrorResolverService extends BaseServiceErrorResolverService {
  codes = {
    'InvalidEanCode': `Die EAN des Artikels ist nicht gültig.`
  };
}
